import ConnectionBar from "./ConnectionBar/ConnectionBar";
import { Header } from "./Header/Header";
import { StatusReportsTableDetails } from "./StatusReportsTableDetails";
import { MillNetworkDetailsProvider } from "contexts/MillNetworkDetailsContext/MillNetworkDetailsProvider";

export const MillLocalserverMetrics = () => {
    return (
        <MillNetworkDetailsProvider>
            <div>
                <Header />
                <ConnectionBar />
                <StatusReportsTableDetails />
            </div>
        </MillNetworkDetailsProvider>
    );
};
